<template>
  <div class="p-4 flex flex-col" style="max-width:500px;">
    <!-- The center of the page -->
    <div class="mb-auto">
      <transition name="question" mode="out-in" v-on:after-enter="afterEnter">
        <div :key="qNo">
          <div class="font-semibold text-lg text-center">
            {{getQuestion()}}
          </div>
          <div v-if="customerSurvey" class="w-full flex text-grey-dark text-sm pt-6">
            <span class="w-1/3">0</span>
            <span class="w-1/3 text-center">5</span>
            <span class="w-1/3 text-right">10</span>
          </div>
          <div v-else class="w-full flex text-grey-dark text-sm pt-6">
            <span class="w-1/3">Disagree</span>
            <span class="w-1/3 text-center">Neutral</span>
            <span class="w-1/3 text-right">Agree</span>
          </div>
          <div class="employee-confidence-slider">
            <vue-slider tooltip="always" tooltip-dir="bottom" v-bind="options" ref="slider" v-model="value" :piecewise="true" :piecewiseStyle="{'backgroundColor': '#ccc','width': '4px','height': '4px'}"></vue-slider>
          </div>
          <div class="w-full flex justify-between text-grey-dark text-sm px-2">
            <span>0</span>
            <span>10</span>
          </div>

        </div>
      </transition>
      <transition name="question-stagger" mode="out-in">
        <div :key="'buttons' + qNo">
          <div class="flex justify-center pt-8">
            <button class="mx-2 rounded px-8 py-2 uppercase tracking-wide font-semibold" v-if="qNo > 1" @click="backQuestion" type="button" :style="{color: brandColor}">Back</button>
            <button class="mx-2 text-white rounded px-8 py-2 uppercase tracking-wide font-semibold" @click="nextQuestion" type="button"  :style="{backgroundColor: brandColor}">Next</button>
          </div>
        </div>
      </transition>
    </div>
    <div class="text-center">
        <div class="text-sm text-grey-dark">
          <transition name="number" mode="out-in">
          <span class="inline-block" :key="qNo">{{qNo}}</span>
          </transition>
          of {{maxQuestion}}
        </div>

      <div>
        <div style="max-width:120px;height:6px;" class="w-full bg-grey-lighter rounded-full mx-auto">
          <div :style="{width:`${progressPercent}%`}" style="transition:0.2s all; transition-delay:300;" class="h-full bg-grey w-1/2 rounded-full"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'
// import axios from 'axios'

export default {
  name: 'question',
  props: ['brandColor', 'company'],
  components: {
    vueSlider
  },
  created () {
    this.setValue()
    if (localStorage.getItem('surveyType') === 'company' && this.getObj('company')) {
      this.img = this.getObj('company').logo
    }

    if (localStorage.getItem('surveyType') === 'customer') {
      this.maxQuestion = 1
    }

    if (this.getObj('surveySubmit') === true) {
      this.options.disabled = true
    }
    // When the page is transitioning on load, the slider component breaks. This event waits for the parent to stop transitioning before reloading the component
    this.$parent.$on('refresh-slider', () => {
      this.$refs.slider.refresh()
    })
  },
  beforeDestroy () {
    this.$parent.$off('refresh-slider')
  },
  data () {
    return {
      customerSurvey: false,
      img: '',
      disabled: false,
      qNo: 1,
      maxQuestion: 12,
      value: 5,
      customerQuetion: [
        `On a scale of zero to ten, how confidently would you recommend ${this.company} to a friend or colleague?`
      ],
      questions: [
        'My role contributes directly to the organisation\'s success.',
        'My immediate team has the skills required to deliver to the organisation\'s goals.',
        'My manager has the expertise required to enable me to be successful in my role.',
        'I am confident in the ability of our Senior Leaders to drive our organisation\'s success.',
        'I understand the strategic direction of the organisation and its goals for the future.',
        'I am confident in my organisation\'s ability to successfully adapt and change.',
        'The different parts of the organisation work well together to achieve the organisation\'s goals.',
        'My organisation offers me the development required to continue enhancing my skills.',
        'Being part of this organisation positively supports my career aspirations.',
        'The communication within my organisation is transparent and efficient.',
        'I would recommend this organisation as a great place to work.',
        'Overall, I have confidence in the organisation\'s future success.'

        // 'Most days, I see positive results because of my contribution.',
        // 'The people I work with take accountability for and ownership of the results they produce.',
        // 'My manager provides me with the tools, training and guidance I need to effectively perform my job.',
        // 'Senior leaders in my organisation have the experience, skills and abilities to contribute positively to our overall success.',
        // 'I would recommend this organisation as a great place to work.',
        // 'My organisation in its current state adapts well to change.',
        // 'My organisation offers me opportunities to learn and progress in my career.',
        // 'There are no barriers to open and efficient communication in my organisation.'
      ],
      options: {
        eventType: 'auto',
        width: 'auto',
        height: 15,
        dotSize: 30,
        tooltip: false,
        min: 0,
        max: 10,
        disabled: false,
        sliderStyle: {
          backgroundColor: this.brandColor,
          boxShadow: 'none'
        }
      }
    }
  },
  methods: {
    afterEnter () {
      this.$nextTick(() => this.$refs.slider.refresh())
    },
    getQuestion () {
      if (localStorage.getItem('surveyType') === 'customer') {
        this.customerSurvey = true
        return this.customerQuetion[this.qNo - 1].replace('[brand/organisation]', this.getObj('company').name)
      } else {
        return this.questions[this.qNo - 1]
      }
    },
    getObj (name) {
      let obj = localStorage.getItem(name)
      return JSON.parse(obj)
    },
    setValue () {
      let obj = this.getObj('user-data')
      this.value = obj['ans_' + this.qNo]
    },
    backQuestion () {
      this.qNo--
      this.setValue()
    },
    nextQuestion () {
      let obj = localStorage.getItem('user-data')
      let data = JSON.parse(obj)
      data['ans_' + this.qNo] = this.value
      localStorage.setItem('user-data', JSON.stringify(data))
      if (this.qNo === this.maxQuestion) {
        let params = {}
        if (localStorage.getItem('surveyType') !== 'generic') {
          params = { link: this.$route.params.link }
        }
        this.$router.push({name: 'submit', params: params})
      } else {
        this.qNo++
        this.setValue()
      }

      // this.$router.push({name: 'question', params: { link: this.$route.params.link, qno: this.$route.params.qno++ }})
    }
  },
  computed: {
    progressPercent () {
      return this.qNo / this.maxQuestion * 100
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Question.vue